import { render, staticRenderFns } from "./TimeStats.vue?vue&type=template&id=472b7c19&scoped=true"
import script from "./TimeStats.vue?vue&type=script&lang=js"
export * from "./TimeStats.vue?vue&type=script&lang=js"
import style0 from "./TimeStats.vue?vue&type=style&index=0&id=472b7c19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472b7c19",
  null
  
)

export default component.exports